import axios from 'axios';
import { baseURL } from '../../globalUtils/axiosConfig';

export const notificationSaga = {
  async getNotifications(userId) {
    try {
      const response = await axios.get(`${baseURL}/api/notifications`, {
        params: { userId }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async markAsRead(notificationId) {
    try {
      const response = await axios.patch(
        `${baseURL}/api/notifications/${notificationId}/read`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async markAllAsRead(userId) {
    try {
      const response = await axios.patch(
        `${baseURL}/api/notifications/mark-all-read`,
        { userId }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteNotification(notificationId) {
    try {
      const response = await axios.delete(
        `${baseURL}/api/notifications/${notificationId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default notificationSaga;
